/* set mobile slider to only show 1.4 slides */
var interval;

function onloadFunctions()
{
    checkSlides();
    interval = setInterval(checkSlides, 500);
}

/* ... code ... */

function checkSlides()
{

      var slidesSet = $('#categorypage-nosto-2 .slick-slide').length
    if(slidesSet)
    {

          clearInterval(interval);
          if (window.matchMedia("(max-width: 768px)").matches){
            //$('#categorypage-nosto-2 .slick-slider').slick('slickSetOption', 'slidesToShow', 1.4, true)  
            $('#categorypage-nosto-2 .slick-slider').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              responsive: [
              {
                breakpoint: 768,
                settings: {
                  centerMode: true,
                  centerPadding: '40px',
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
              ]
            });
          }

    }
}
onloadFunctions();